const defaultFailActionRu = (jqXHR) => {
    window.alert(
        "Ошибка при выполнении действия\n" +
        "Статус: " + jqXHR['statusText'] + "\n" +
        "Код статуса: " + jqXHR['status'] + "\n" +
        "Ответ сервера: " + jqXHR['responseText']
    );
};

const defaultFailActionEn = (jqXHR) => {
    window.alert(
        "Action failed\n" +
        "Status: " + jqXHR['statusText'] + "\n" +
        "Status code: " + jqXHR['status'] + "\n" +
        "Server response: " + jqXHR['responseText']
    );
};

const focusOnNextInputByEnter = ($currentInput) => {
    if (event.which === ENTER_KEY_CODE) {
        event.preventDefault();
        const currentTabIndex = Number($currentInput.attr("tabindex"));
        const nextTabIndex = currentTabIndex + 1;
        const $nextInput = $(`input:visible[tabindex=${nextTabIndex}]`);

        if ($nextInput) {
            $nextInput.focus();
        }
    }
};

const decodeHtml = (html) => {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
};
